module.exports = __webpack_public_path__ + "media/images/icons/text-ad9a5786d3b01eebd8e9a31743d25662.svg";